/**
 * SavedBuddyGroupPicker -- Lets user select from their saved buddy groups.
 * Used within the registration flow to reuse a previously created group.
 */
import { Users, ChevronRight } from 'lucide-react';
import type { BuddyGroupSummary } from '@/types/buddy-groups';

interface SavedBuddyGroupPickerProps {
  savedGroups: BuddyGroupSummary[];
  onSelect: (groupId: string) => void;
  selectedId?: string;
}

export function SavedBuddyGroupPicker({ savedGroups, onSelect, selectedId }: SavedBuddyGroupPickerProps) {
  if (savedGroups.length === 0) return null;

  return (
    <div className="space-y-2">
      <p className="text-sm font-medium text-muted-foreground">Your Saved Groups</p>
      <div className="space-y-1">
        {savedGroups.map((group) => (
          <button
            key={group.id}
            type="button"
            onClick={() => onSelect(group.id)}
            className={`w-full flex items-center justify-between p-3 rounded-lg border text-left transition-colors ${
              selectedId === group.id
                ? 'border-primary bg-primary/5'
                : 'border-border hover:border-primary/50 hover:bg-muted/50'
            }`}
          >
            <div className="flex items-center gap-2">
              <Users className="h-4 w-4 text-muted-foreground" />
              <div>
                <span className="text-sm font-medium">{(group.group_name ?? 'Unnamed Group')}</span>
                <span className="text-xs text-muted-foreground ml-2">
                  {group.member_count} member{group.member_count !== 1 ? 's' : ''}
                </span>
              </div>
            </div>
            <ChevronRight className="h-4 w-4 text-muted-foreground" />
          </button>
        ))}
      </div>
    </div>
  );
}
